import {
    ALLOWED_FILE_TYPES,
    APPROVED,
    PENDING,
    REJECTED,
    ROLES,
    SUBMITTED,
    WINDOW_WIDTH,
} from 'components/ui/utils/constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import moment from 'moment'
import deepParseJson from './deepParseJson'
import { TOKEN_KEY } from './helperConstants'
import { getData } from './restService'
export const isValidArray = (arr) =>
    (Array.isArray(arr) && arr.length > 0) || false

export const deepCopyArrayOfObjects = (arr) =>
    (isValidArray(arr) && arr.map((a) => ({ ...a }))) || []

export const isObject = (val) => val && val instanceof Object

export const setSessionStorageItem = (key, val) => {
    sessionStorage.setItem(key, val)
}

export const clearSessionStorage = () => sessionStorage.clear()

export const getFormattedDate = (format, date = new Date()) =>
    moment(date).format(format)

export const alphaChars = (text) => /^[a-zA-Z]+$/.test(text)

export const alphaNumericChars = (text) => /^[a-zA-Z0-9]+$/.test(text)

export const alphaNumericCharsWithSpace = (text) =>
    /^(?! )[a-zA-Z0-9 ]+$/.test(text)

export const capChars = (text) => /[A-Z]/.test(text)

export const nums = (text) => /[0-9]/.test(text)

export const onlyNums = (text) => /^[0-9]*$/.test(text)

export const specialChar = (text) => /[@#!]/.test(text) // @ # !

export const validPhoneNumber = (text) => text.length === 10 && onlyNums(text)

// This is kept for future validations and debugging
// export const validPhoneNumber = (text) => /[0-9+\-\(\)\s]+/.test(text)

export const validEmail = (text) => /^\S+@\S+\.\S+$/.test(text)

export const getMB = (bytes) => `${Math.round(bytes / 1000 / 1000)}MB`

export const setDialogStyles = (windowWidth) => {
    const dialogEl = document.getElementsByClassName('dialog-content')[0]

    dialogEl.style.width = '100vw'
    dialogEl.style.marginLeft =
        windowWidth >= WINDOW_WIDTH.SCREEN_1900
            ? '-24rem'
            : windowWidth >= WINDOW_WIDTH.SCREEN_1600
            ? '-14rem'
            : windowWidth >= WINDOW_WIDTH.SCREEN_1400
            ? '-9rem'
            : windowWidth >= WINDOW_WIDTH.SCREEN_1300
            ? '-6.7rem'
            : '-4rem'
    dialogEl.style.marginTop = '0rem'
    dialogEl.style.height = '100vh'
    dialogEl.style.borderRadius = 0
}
export const getFirstChar = (str) => {
    if (str?.length === 0) {
        return null
    }
    return str?.charAt(0) || ''
}

export const beforeUploadUtil = (
    files,
    fileList,
    maxUpload,
    allowedFileType = [...ALLOWED_FILE_TYPES.IMAGES, ...ALLOWED_FILE_TYPES.PDF],
    maxFileSize = 5000000
) => {
    let valid = true
    let errorMessage = ''
    let fileExts = ''

    if (fileList.length >= maxUpload) {
        valid = false
        errorMessage = `You can only upload ${maxUpload} file(s)`
    } else if (files) {
        for (const f of files) {
            if (!allowedFileType.includes(f.type)) {
                valid = false
                allowedFileType.forEach(
                    (fl) => (fileExts += `${fl.split('/').pop()}, `)
                )
                errorMessage = `Please upload a ${fileExts} file!`
            }

            if (f.size >= maxFileSize) {
                valid = false
                errorMessage = `Uploaded file cannot more then ${getMB(
                    maxFileSize
                )}!`
            }
        }
    }

    return { valid, errorMessage }
}
export const getToken = () => {
    // const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    // const persistData = deepParseJson(rawPersistData)
    // return persistData.auth.session.token
    return localStorage.getItem(TOKEN_KEY)
}

export const formatResForSelect = (res) =>
    (isValidArray(res) &&
        res.map((r) => ({
            value: r.id,
            key: r.key,
            label: r.name['en-IN'] || '',
        }))) ||
    []

export const getStatusStyling = (status) => {
    switch (status) {
        case APPROVED:
            return {
                msg: 'Approved',
                bgColor: 'green-100',
                txtColor: 'green-600',
                width: 'w-16',
                title: 'Documents are verified.',
            }
        case REJECTED:
            return {
                msg: 'Rejected',
                bgColor: 'red-100',
                txtColor: 'red-600',
                width: 'w-16',
                subTitle1: 'Your Company has been rejected',
            }
        case SUBMITTED:
            return {
                msg: 'Submitted',
                bgColor: 'theme-status-warning-light',
                txtColor: 'theme-warning-dark',
                width: 'w-20',
            }
        case PENDING:
        default:
            return {
                msg: 'Pending for verification',
                bgColor: 'theme-status-warning-light',
                txtColor: 'theme-warning-dark',
                width: 'w-40',
                title: 'Documents are not verified. Please verify the attached documents',
            }
    }
}

const { SELLER_ADMIN, SELLER_MEMBER, OPERATOR } = ROLES

export const isSellerAdmin = (role) => role === SELLER_ADMIN

export const isSellerMember = (role) => role === SELLER_MEMBER

export const isOperator = (role) => role === OPERATOR

export const formatDate = (date) => {
    if (isValidArray(date)) {
        const formattedDate =
            new Date(date)
                ?.toLocaleString()
                ?.replace(/(.*)\D\d+/, '$1')
                ?.split(',')
                ?.slice(0, 1) || []
        return formattedDate
    }
    return null
}

export const formateUSLocaleDate = (date) => {
    if (!(date instanceof Date)) return ''
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
    }).format(date)
}

export const downloadFileFromUrl = async (url, keyInResponse) => {
    const response = await getData(url)

    if (response[keyInResponse]) {
        // Create a link element to download the image
        const link = document.createElement('a')
        link.href = response[keyInResponse]
        link.target = '_blank'
        link.download = 'downloaded_image.jpg'
        document.body.appendChild(link)

        // Click the link to trigger the download
        link.click()

        // Cleanup
        document.body.removeChild(link)
    } else {
        console.error('Invalid Image!')
    }
}

export const formatCentAmount = (centAmount, fractionDigits) => {
    const amount = parseInt(centAmount, 10)

    const divisor = Math.pow(10, fractionDigits)

    const formattedAmount = (amount / divisor).toFixed(fractionDigits)

    return formattedAmount
}
